import React from 'react';

import './style.sass';

import musicIcon from 'assets/img/icons/music-icon.svg';

import { Button } from '../Button';
import { Routes } from 'src/types/routes';

export const Greetings = () => {
    return (
        <div className="greetings">
            <div className="greetings__icon-wrapper">
                <div className="greetings__icon">
                    <img src={musicIcon}/>
                </div>
            </div>

            <div className="greetings__title-block">
                <h1 className="title-h1 dark-violet">
                Welcome to Explicit!
                </h1>
                <h1 className="title-h1 dark-violet">
                Create your first campaign.
                </h1>
            </div>

            <p className="greetings__desc p2-medium grey-1">
                Proceed to the campaign picker and choose the one that fits you best!
            </p>

            <Button
                className="greetings__btn"
                text="choose campaign"
                size='big'
                to={Routes.Campaigns}
            />

            <span className="greetings__support p2-medium grey-1">
                Already purchased a campaign?
                {' '}
                <a
                    className="greetings__support p2-semi-bold violet-text"
                    href="mailto:support@explicitpromo.com "
                >
                    Ask support for help
                </a>
            </span>
        </div>
    );
};
